import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowRight = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/arrow-right">
        <g id="arrow-right">
          <path
            id="Vector"
            d="M9.61943 12.5466C9.49276 12.5466 9.36609 12.5 9.26609 12.4C9.07276 12.2066 9.07276 11.8866 9.26609 11.6933L12.9594 7.99996L9.26609 4.30662C9.07276 4.11329 9.07276 3.79329 9.26609 3.59996C9.45943 3.40662 9.77943 3.40662 9.97276 3.59996L14.0194 7.64662C14.2128 7.83996 14.2128 8.15996 14.0194 8.35329L9.97276 12.4C9.87276 12.5 9.74609 12.5466 9.61943 12.5466Z"
          />
          <g id="Vector_2">
            <mask id="path-2-inside-1_3025_153">
              <path d="M13.552 8.5H2.33203C2.0587 8.5 1.83203 8.27333 1.83203 8C1.83203 7.72667 2.0587 7.5 2.33203 7.5H13.552C13.8254 7.5 14.052 7.72667 14.052 8C14.052 8.27333 13.8254 8.5 13.552 8.5Z" />
            </mask>
            <path d="M13.552 8.5H2.33203C2.0587 8.5 1.83203 8.27333 1.83203 8C1.83203 7.72667 2.0587 7.5 2.33203 7.5H13.552C13.8254 7.5 14.052 7.72667 14.052 8C14.052 8.27333 13.8254 8.5 13.552 8.5Z" />
            <path
              d="M13.552 7.5H2.33203V9.5H13.552V7.5ZM2.33203 7.5C2.61098 7.5 2.83203 7.72105 2.83203 8H0.832031C0.832031 8.82562 1.50641 9.5 2.33203 9.5V7.5ZM2.83203 8C2.83203 8.27895 2.61098 8.5 2.33203 8.5V6.5C1.50641 6.5 0.832031 7.17438 0.832031 8H2.83203ZM2.33203 8.5H13.552V6.5H2.33203V8.5ZM13.552 8.5C13.2731 8.5 13.052 8.27895 13.052 8H15.052C15.052 7.17438 14.3776 6.5 13.552 6.5V8.5ZM13.052 8C13.052 7.72105 13.2731 7.5 13.552 7.5V9.5C14.3776 9.5 15.052 8.82562 15.052 8H13.052Z"
              mask="url(#path-2-inside-1_3025_153)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

ArrowRight.displayName = 'ArrowRight';
